<template>
    <div>
        <el-card shadow='never'>
            <div slot='header' class='clearfix'>
                <span>商品支付成功后数据映射配置</span>
            </div>
            <el-form label-position='top'>
                <el-form-item label='选择云存储应用'>
                    <el-cascader size='mini' v-model='cascadeValue' :options='appOptions'
                                 @change='handleChange'></el-cascader>
                </el-form-item>
                
                <slot v-bind:chooseApp='currentChooseApp' />
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { applicationCredentialApi } from '@api/Storage/applicaitonCredentialConfig';
import { message } from '@/utils/message';
import { storageSchemaApi } from '@api/Storage/storageSchema';
import { deepCopy } from '@/utils/object';

export default {
    name: 'ProjectCloudStorage',
    props: {
        projectAppId: {
            type: String
        },
        selectedAppId: {
            type: String
        },
        selectedClassName: {
            type: String
        }
    },
    emits: ['appChange'],
    data() {
        return {
            appOptions: [],
            cascadeValue: [],
            currentChooseApp: {
                appId: undefined,
                schemaOptions: undefined
            }
        };
    },
    created() {
        this.init();
    },
    watch: {
        projectAppId() {
            this.init();
        },
        selectedAppId() {
            this.selectItems();
        },
        selectedClassName() {
            this.selectItems();
        }
    },
    methods: {
        init() {
            this.appOptions = [];
            this.cascadeValue = [];
            this.loadCloudApplication();
        },
        selectItems() {
            if (this.selectedAppId) {
                this.cascadeValue.push(this.selectedAppId);
            }
            if (this.selectedClassName) {
                this.cascadeValue.push(this.selectedClassName);
            }
            console.log(this.selectedAppId);
            console.log(this.selectedClassName);
            console.log(this.cascadeValue);
        },
        loadCloudApplication() {
            this.appOptions = [];
            applicationCredentialApi.queryList().then(result => {
                if (result.code === 200) {
                    let appList = result.data;
                    if (!appList) {
                        message.error('未找到有效的云存储应用!');
                        return;
                    }
                    appList = appList.filter(t => t.projectAppId === this.projectAppId);
                    if (!appList || appList.length === 0) {
                        message.warning('该项目尚未创建云存储应用');
                        return;
                    }
                    appList.forEach((t, index) => {
                        let option = {
                            label: t.chineseName,
                            value: t.appId,
                            children: []
                        };
                        storageSchemaApi.queryAllSchema(t.appId).then(result => {
                            if (result.code === 200) {
                                let schemaList = result.data.results;
                                schemaList.forEach((f, fIndex) => {
                                    let childOption = {
                                        label: f.objectId,
                                        value: f.objectId,
                                        fieldOption: f.fieldOption,
                                        defaultACL: {
                                            setDefaultACL: {},
                                            systemDefaultACL: {
                                                '*': {
                                                    read: true,
                                                    write: true
                                                }
                                            }
                                        },
                                        customFieldTypeMap: new Map,
                                        baseFieldNameList: ['objectId', 'ACL', 'createUserId', 'updateUserId', 'createdAt', 'updatedAt'],
                                        allFieldType: {},
                                        sortableTypeSet: new Set,
                                        queryFieldType: {}
                                    };
                                    option.children.push(childOption);
                                    
                                    if (fIndex === schemaList.length - 1) {
                                        this.appOptions.push(option);
                                    }
                                    
                                    let fieldOptions = f.fieldOption;
                                    if (f.metadata && f.metadata.default_acp) {
                                        childOption.defaultACL.setDefaultACL = f.metadata.default_acp;
                                    }
                                    
                                    if (fieldOptions && Object.keys(fieldOptions).length !== 0) {
                                        let keyArr = Object.keys(fieldOptions);
                                        keyArr.forEach((key, index) => {
                                            if (childOption.customFieldTypeMap.has(key)) {
                                                return;
                                            }
                                            if (childOption.baseFieldNameList.includes(key)) {
                                                return;
                                            }
                                            
                                            let fieldType = fieldOptions[key]['type'];
                                            let require = fieldOptions[key]['required'];
                                            childOption.allFieldType[key] = {
                                                type: fieldType
                                            };
                                            childOption.customFieldTypeMap.set(key, {
                                                type: fieldType,
                                                sort: childOption.sortableTypeSet.has(fieldType),
                                                require: require
                                            });
                                            if (index === keyArr.length - 1) {
                                                childOption.queryFieldType = deepCopy(childOption.allFieldType);
                                                delete childOption.queryFieldType.ACL;
                                            }
                                        });
                                    }
                                    
                                    if (index === appList.length - 1 && fIndex === schemaList.length - 1) {
                                        console.log(this.appOptions);
                                        this.selectItems();
                                        if (this.cascadeValue.length !== 0) {
                                            this.loadCloudField(this.cascadeValue);
                                        }
                                    }
                                });
                            }
                        });
                    });
                }
            });
        },
        handleChange(value) {
            this.loadCloudField(value);
        },
        loadCloudField(value) {
            let appId = value[0];
            let className = value[1];
            this.appOptions.forEach(t => {
                if (t.value === appId) {
                    t.children.forEach(f => {
                        if (f.value === className) {
                            this.currentChooseApp.appId = appId;
                            this.currentChooseApp.schemaOptions = f;
                            this.handleAppChange();
                        }
                    });
                }
            });
        },
        handleAppChange() {
            this.$emit('appChange', this.currentChooseApp);
        }
    }
};
</script>

<style scoped lang='scss'>

</style>
